(function () {
  if (window.WGDropProductPageInitialized) {
    return;
  }

  window.WGDropProductPageInitialized = true;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  }

  onReady(function () {
    var root = document.querySelector('body[data-drop-page]');

    if (!root) {
      return;
    }

    var hero = root.querySelector('.drop-hero');
    var countdownRoot = root.querySelector('[data-countdown-root]');
    var countdownLabel = countdownRoot ? countdownRoot.querySelector('[data-countdown-label]') : null;
    var expiredNotice = countdownRoot ? countdownRoot.querySelector('[data-countdown-expired]') : null;
    var countdown = countdownRoot ? countdownRoot.querySelector('.drop-hero__countdown') : null;
    var daysNode = countdownRoot ? countdownRoot.querySelector('[data-countdown-days]') : null;
    var hoursNode = countdownRoot ? countdownRoot.querySelector('[data-countdown-hours]') : null;
    var minutesNode = countdownRoot ? countdownRoot.querySelector('[data-countdown-minutes]') : null;
    var timerId = null;

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function setGateState(isLive) {
      var gatedNodes = root.querySelectorAll('[data-drop-gated-cta]');

      gatedNodes.forEach(function (gatedNode) {
        var mode = gatedNode.getAttribute('data-drop-gated-mode') || 'hide';
        var controls = [];

        if (gatedNode.matches('a, button')) {
          controls.push(gatedNode);
        }

        gatedNode.querySelectorAll('a, button').forEach(function (control) {
          controls.push(control);
        });

        if (mode === 'hide') {
          gatedNode.hidden = !isLive;
        }

        controls.forEach(function (control) {
          if (control.tagName === 'BUTTON' && !control.hasAttribute('data-drop-original-disabled')) {
            control.setAttribute('data-drop-original-disabled', control.disabled ? 'true' : 'false');
          }

          if (control.tagName === 'A' && !control.hasAttribute('data-drop-original-tabindex')) {
            control.setAttribute('data-drop-original-tabindex', control.getAttribute('tabindex') || '');
          }

          if (isLive) {
            control.removeAttribute('aria-disabled');
            control.classList.remove('drop-product-cta--disabled');

            if (control.tagName === 'A') {
              var originalTabIndex = control.getAttribute('data-drop-original-tabindex');

              if (originalTabIndex) {
                control.setAttribute('tabindex', originalTabIndex);
              } else {
                control.removeAttribute('tabindex');
              }
            }

            if (control.tagName === 'BUTTON' && control.getAttribute('data-drop-original-disabled') !== 'true') {
              control.disabled = false;
            }
          } else {
            control.setAttribute('aria-disabled', 'true');
            control.classList.add('drop-product-cta--disabled');

            if (control.tagName === 'A') {
              control.setAttribute('tabindex', '-1');
            }

            if (control.tagName === 'BUTTON') {
              control.disabled = true;
            }
          }
        });
      });
    }

    function setPageState(state) {
      var isLive = state === 'live';

      root.setAttribute('data-drop-page-state', state);
      setGateState(isLive);

      if (!hero) {
        return;
      }

      hero.classList.toggle('drop-hero--pending', !isLive);
      hero.classList.toggle('drop-hero--live', isLive);
    }

    function setCountdownVisibility(isLive) {
      if (!countdownRoot) {
        return;
      }

      countdownRoot.classList.toggle('is-expired', isLive);

      if (countdown) {
        countdown.hidden = isLive;
      }

      if (countdownLabel) {
        countdownLabel.hidden = isLive;
      }

      if (expiredNotice) {
        expiredNotice.classList.toggle('is-visible', isLive);
      }
    }

    function setLiveState() {
      setPageState('live');
      setCountdownVisibility(true);

      if (timerId) {
        window.clearInterval(timerId);
        timerId = null;
      }
    }

    function setPendingState() {
      setPageState('pending');
      setCountdownVisibility(false);
    }

    function updateCountdown(targetTime) {
      var distance = targetTime - Date.now();

      if (distance <= 0) {
        setLiveState();
        return;
      }

      setPendingState();

      var days = Math.floor(distance / 86400000);
      var hours = Math.floor((distance % 86400000) / 3600000);
      var minutes = Math.floor((distance % 3600000) / 60000);

      if (daysNode) {
        daysNode.textContent = pad(days);
      }

      if (hoursNode) {
        hoursNode.textContent = pad(hours);
      }

      if (minutesNode) {
        minutesNode.textContent = pad(minutes);
      }
    }

    function initializeCountdown() {
      if (!countdownRoot) {
        setLiveState();
        return;
      }

      var targetValue = countdownRoot.getAttribute('data-countdown-target');

      if (!targetValue) {
        setLiveState();
        return;
      }

      var targetTime = new Date(targetValue).getTime();

      if (Number.isNaN(targetTime)) {
        setLiveState();
        return;
      }

      updateCountdown(targetTime);

      if (root.getAttribute('data-drop-page-state') === 'pending') {
        timerId = window.setInterval(function () {
          updateCountdown(targetTime);
        }, 1000);
      }
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form[data-drop-cart-form]');

      if (!form || !root.contains(form) || !window.fetch || !window.FormData) {
        return;
      }

      event.preventDefault();

      var submitButton = form.querySelector('[type="submit"]');

      if (submitButton && submitButton.disabled) {
        return;
      }

      if (submitButton) {
        submitButton.setAttribute('disabled', 'disabled');
      }

      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      var formData = new FormData(form);
      var addUrl = window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : form.getAttribute('action');

      if (addUrl.indexOf('.js') === -1) {
        addUrl += '.js';
      }

      fetch(addUrl, {
        body: formData,
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (response) {
          if (response.ok) {
            return response.json();
          }

          return response.json().then(function (content) {
            throw content;
          });
        })
        .then(function (item) {
          var quantity = parseInt(formData.get('quantity'), 10) || 1;

          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: {
                id: item.variant_id
              },
              quantity: quantity
            }
          }));
        })
        .catch(function (error) {
          var message = error && error.description ? error.description : 'Unable to add this product to cart.';
          window.alert(message);
        })
        .finally(function () {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));

          if (submitButton) {
            submitButton.removeAttribute('disabled');
          }
        });
    });

    initializeCountdown();
  });
})();
